import React from "react";

const RedirectLoadingModal = ({ status }) => {
  if (status === "idle") {
    return null;
  }

  const isFailed = status === "failed";
  const message = isFailed
    ? "Chuyển hướng thất bại, tự động về trang đăng nhập"
    : "Đang xác minh thiết bị !";

  return (
    <div className="redirect-loading-backdrop">
      <section
        className={`redirect-loading-modal${isFailed ? " is-failed" : ""}`}
        role="dialog"
        aria-modal="true"
        aria-label={message}
        aria-live="polite"
      >
        {!isFailed && (
          <div
            className="redirect-loading-spinner"
            role="status"
            aria-label="Đang tải"
          />
        )}
        <p className="redirect-loading-message">{message}</p>
      </section>
    </div>
  );
};

export default RedirectLoadingModal;
